<template>
  <div
    v-for="(result, index) in results"
    :key="result.id"
  >
    <component
      :is="cardType(result.type)"
      :search-result="result"
      :result-position="index + 1"
      @open-feedback-modal="$emit('openFeedbackModal')"
      @result-clicked="$emit('result-clicked', $event)"
    />
  </div>
</template>

<script setup>
import CmsPageCard from './ResultCards/CmsPageCard.vue';
import DocumentCard from './ResultCards/DocumentCard.vue';
import FormCard from './ResultCards/FormCard';
import LiveFeedCard from './ResultCards/LiveFeedCard';
import NewsCard from './ResultCards/NewsCard';
import StaffCard from './ResultCards/StaffCard.vue';
import AthleticsCard from './ResultCards/AthleticsCard.vue';
import EventsCard from './ResultCards/EventCard.vue';
import LinkCard from './ResultCards/LinkCard.vue';
import DefaultSearchResultCard from './ResultCards/DefaultSearchResultCard.vue';

defineProps({
  results: {
    type: Array,
    default: () => [],
  },
});

defineEmits(['result-clicked', 'openFeedbackModal']);

function cardType(resultType) {
  switch (resultType) {
    case 'cms_page':
      return CmsPageCard;
    case 'public_file':
    case 'documents_asset':
      return DocumentCard;
    case 'form':
      return FormCard;
    case 'directory':
      return StaffCard;
    case 'article':
      return NewsCard;
    case 'live_feed':
      return LiveFeedCard;
    case 'event':
      return EventsCard;
    case 'scores_schedule':
      return AthleticsCard;
    case 'cms_link':
      return LinkCard;
    default:
      return DefaultSearchResultCard;
  }
}
</script>
